import React, { useState, useEffect, createContext, useContext } from "react";
import { useSession } from "next-auth/react";

const SelectedUserAccountContext = createContext();

export const useSelectedUserAccount = () => useContext(SelectedUserAccountContext);

export const SelectedUserAccountProvider = ({ children }) => {
  const { data: session } = useSession();

  const [selectedUser, setSelectedUser] = useState({
    user_id: null,
    name: null,
    profile_image: null,
  });

  // Set default from session ONLY if no user selected yet
  useEffect(() => {
    if (
      !selectedUser.user_id && // don’t overwrite if user already chosen
      session?.settings?.user_id
    ) {
      setSelectedUser({
        user_id: session.settings.user_id,
        name: session.user?.name || null,
        profile_image: session.settings?.profile_image || null,
      });
    }
  }, [session]); // deliberately NOT including selectedUser in deps

  const selectUserAccount = (user) => setSelectedUser(user);

  return (
    <SelectedUserAccountContext.Provider value={{ selectedUser, selectUserAccount }}>
      {children}
    </SelectedUserAccountContext.Provider>
  );
};
